/*
	•	Factory for non-semantic color schemes
*/
const createScheme = (c: string, overrides: Record<string, string> = {}) => ({
  '--text-subtle': `var(--color-${c}-1000)`,
  '--background-subtle': `var(--color-${c}-200)`,
  '--text-subtle-hover': `var(--color-${c}-1100)`,
  '--background-subtle-hover': `var(--color-${c}-300)`,
  '--text-bold': 'white',
  '--background-bold': `var(--color-${c}-800)`,
  '--background-bold-hover': `var(--color-${c}-900)`,
  '--text-on-white': `var(--color-${c}-800)`,
  ...overrides
})

/*
	•	Semantic themes
*/
const info = {
  '--text-subtle': 'var(--color-info-mid)',
  '--background-subtle': 'var(--color-info-light)',
  '--text-bold': 'white',
  '--background-bold': 'var(--color-info)',
  '--text-on-white': 'var(--color-info)'
}
const neutral = {
  '--text-subtle': 'var(--color-grey-900)',
  '--background-subtle': 'var(--color-grey-100)',
  '--text-bold': 'white',
  '--background-bold': 'var(--color-grey-800)',
  '--text-on-white': 'var(--color-grey-800)'
}
const success = {
  '--text-subtle': 'var(--color-success-mid)',
  '--background-subtle': 'var(--color-success-light)',
  '--text-bold': 'white',
  '--background-bold': 'var(--color-success)',
  '--text-on-white': 'var(--color-success)'
}
const danger = {
  '--text-subtle': 'var(--color-danger-mid)',
  '--background-subtle': 'var(--color-danger-light)',
  '--text-bold': 'white',
  '--background-bold': 'var(--color-danger)',
  '--text-on-white': 'var(--color-danger)'
}
const warning = {
  '--text-subtle': 'var(--color-warning-text)',
  '--background-subtle': 'var(--color-warning-light)',
  '--text-bold': 'var(--color-grey-1000)',
  '--background-bold': 'var(--color-warning)',
  '--text-on-white': 'var(--color-warning)'
}

/*
	•	Non-semantic themes
*/
export const badgeSemanticNames = [
  'info',
  'neutral',
  'success',
  'danger',
  'warning'
]
export const colorSchemes = {
  info,
  neutral,
  success,
  danger,
  warning,
  primary: createScheme('primary'),
  grey: createScheme('grey'),
  blue: createScheme('blue'),
  pink: createScheme('pink'),
  purple: createScheme('purple', {
    '--text-on-white': 'var(--color-purple-700)'
  }),
  cyan: createScheme('cyan'),
  green: createScheme('green'),
  magenta: createScheme('magenta'),
  red: createScheme('red', {
    '--background-subtle-hover': 'var(--color-red-400)'
  }),
  teal: createScheme('teal'),
  orange: createScheme('orange', {
    '--text-bold': 'var(--color-grey-1200)',
    '--background-bold': 'var(--color-orange-600)',
    '--background-bold-hover': 'var(--color-orange-700)',
    '--text-on-white': 'var(--color-orange-1000)'
  }),
  yellow: createScheme('yellow', {
    '--text-bold': 'var(--color-grey-1200)',
    '--background-bold': 'var(--color-yellow-500)',
    '--background-bold-hover': 'var(--color-yellow-600)',
    '--text-on-white': 'var(--color-yellow-900)'
  }),
  lime: createScheme('lime', {
    '--text-bold': 'var(--color-grey-1200)',
    '--background-bold': 'var(--color-lime-600)',
    '--background-bold-hover': 'var(--color-lime-700)',
    '--text-on-white': 'var(--color-lime-900)'
  }),
  lapis: createScheme('lapis', {
    '--background-bold': 'var(--color-lapis-700)',
    '--text-on-white': 'var(--color-lapis-700)'
  }),
  maroon: createScheme('maroon', {
    '--text-on-white': 'var(--color-maroon-700)'
  }),
  marsh: createScheme('marsh', { '--text-on-white': 'var(--color-marsh-700)' })
}
